import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';
import { fields } from '../constants';
import { replaceInlineStyles } from '../helpers';

import type { FC } from 'react';
import type { RunbookLog } from 'infrastructure/classes/runbook-log';

interface RunbookItemsProps {
  data?: RunbookLog;
}

const RunbookItems: FC<RunbookItemsProps> = ({ data }) => {
  const { t } = useTranslation();

  return fields.map(({ label, key }) => {
    const value = replaceInlineStyles(data?.[key] ?? '');

    return (
      <div className={s['raw-html']} key={key}>
        <p className={s['run-book-label']}>{t(`labels.${label}`)}</p>
        <p
          className={s['run-book-value']}
          dangerouslySetInnerHTML={{
            __html: value,
          }}
        />
      </div>
    );
  });
};
export default RunbookItems;
